import { getTimestamp } from 'app/pages/loanApplication/tabs/loanClosingCDS/EditDrawer/Content/Content.utils';
import _ from 'lodash';

import { PromiseStatus } from 'constants/promise';

export const resolveLiveTimestamp = ({ liveDates, key, storedValue }) =>
  _.has(liveDates, key) ? liveDates[key] : getTimestamp(storedValue);

export const withLiveDate = ({ dates, key, value }) =>
  _.has(dates, key) && dates[key] === value ? dates : { ...dates, [key]: value };

const checkAreAllFulfilled = settledResults =>
  settledResults.every(({ status }) => status === PromiseStatus.FULFILLED);

export const resolveClosingFundingLoadState = ({
  closingInfoResults,
  closingResults,
  fundingResults,
  shouldLoadClosing,
  shouldLoadFunding,
}) => {
  const isClosingInfoLoaded = checkAreAllFulfilled(closingInfoResults);

  return {
    isClosingLoaded:
      shouldLoadClosing && isClosingInfoLoaded && checkAreAllFulfilled(closingResults),
    isFundingLoaded:
      shouldLoadFunding && isClosingInfoLoaded && checkAreAllFulfilled(fundingResults),
  };
};
